import axios from 'axios';
import { OrganogramBatchModel } from '../Models/OrganogramBatchModel';

const categoryOrganogramBatch = (batch: OrganogramBatchModel) => axios.patch('classifications/categories/0/organograms/update-batch', batch);

export default { 
    categoryOrganogramBatch
};